// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__IhAQk","checkbox__wrapper":"Checkbox_checkbox__wrapper__AM63f","checkbox__wrapper_text":"Checkbox_checkbox__wrapper_text__P4T+A"};